import React from "react";
import { Button } from "react-bootstrap";
import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { FaEdit } from "react-icons/fa";
import Form from "react-bootstrap/Form";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
import { updatePlayerPassword } from "../redux/auth/actions";
import { APP_CONST, UPDATE_PASSWORD_FLAG_KEY } from "../config/const";
import { Toaster } from "../utils/toaster";
import { logoutUser } from "../redux/auth/actions";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

const ChangePasswordModal = ({ automaticLoad = false, setParentState }) => {
  const [showModal, setShowModal] = useState(automaticLoad === true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleClose = () => {
    if (setParentState) {
      setParentState(false);
    }
    setShowModal(false);
  };

  const handleShow = () => setShowModal(true);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const validateData = (data) => {
    const dataToValidate = data ? data : formData;
    const { oldPassword, newPassword, confirmPassword } = dataToValidate;
    const newErrors = {};
    if (!oldPassword || oldPassword === "") {
      newErrors.oldPassword = "Old Password cannot be empty";
    }
    if (!newPassword || newPassword === "") {
      newErrors.newPassword = "New Password cannot be empty";
    }
    if (!confirmPassword || confirmPassword === "") {
      newErrors.confirmPassword = "Confirm Password cannot be empty";
    } else if (newPassword !== confirmPassword) {
      newErrors.confirmPassword = "Confirm password must match";
    }
    setErrors(newErrors);
    return newErrors;
  };

  const handleSubmit = async () => {
    const errorData = validateData();
    if (Object.keys(errorData).length > 0) {
      setErrors(errorData);
    } else {
      setIsLoading(true);
      let data = { ...formData };
      delete data.confirmPassword;
      const response = await updatePlayerPassword(data);
      setIsLoading(false);
      if (response) {
        Toaster(APP_CONST.TOAST_TYPE.SUCCESS, response.data.data.message);
        handleClose();
        localStorage.removeItem(UPDATE_PASSWORD_FLAG_KEY);
        dispatch(logoutUser());
        navigate("/");
      }
    }
  };

  const handleChange = (e) => {
    let fieldName = e.target.name;
    let fieldValue = e.target.value;
    let tempFormData = { ...formData, [fieldName]: fieldValue };
    validateData(tempFormData);
    setFormData(tempFormData);
  };

  return (
    <>
      <Button variant="" className="btn_primary" onClick={handleShow}>
        <FaEdit />
      </Button>

      <Modal show={showModal} className="changePasswordModal">
        <Modal.Header closeButton={!automaticLoad}>
          <Modal.Title>Reset Your Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Control
                autoComplete="off"
                // id="formBasicEmail"
                type="password"
                className="changes_password"
                placeholder="Enter old password*"
                name="oldPassword"
                onChange={handleChange}
                isInvalid={!!errors.oldPassword}
              />
              <Form.Control.Feedback type="invalid">
                {errors?.oldPassword}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group
              className="mb-3 position-relative"
              controlId="formBasicPassword"
            >
              <Form.Control
                autoComplete="off"
                // id="newPassInput"
                type={showPassword ? "text" : "password"}
                placeholder="Enter new password*"
                className="changes_password"
                name="newPassword"
                onChange={handleChange}
                isInvalid={!!errors.newPassword}
              />
              <span className="icon" onClick={() => setShowPassword((s) => !s)}>
                {showPassword ? <IoEyeOffOutline /> : <IoEyeOutline />}
              </span>
              <Form.Control.Feedback type="invalid">
                {errors?.newPassword}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group
              className="mb-3 position-relative"
              controlId="formBasicPassword"
            >
              <Form.Control
                autoComplete="off"
                // id="formBasicPassword"
                type="password"
                placeholder="Enter confirm password*"
                className="changes_password"
                name="confirmPassword"
                onChange={handleChange}
                isInvalid={!!errors.confirmPassword}
              />
              <Form.Control.Feedback type="invalid">
                {errors?.confirmPassword}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          {!automaticLoad && (
            <Button variant="" className="btn_outline" onClick={handleClose}>
              Close
            </Button>
          )}
          <Button
            variant=""
            className="btn_primary"
            onClick={() => {
              handleSubmit();
            }}
            disabled={isLoading}
          >
            {isLoading ? "Updating" : "Save Changes"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ChangePasswordModal;
